import styles from './styles.module.scss';

export const Optional = () => {
  return <span className={styles.optionalText}>(Optional)</span>;
};
